/**
 * Only real web addresses become clickable upload links. Old rows hold plain text
 * ("a", "123") — as an href that would navigate somewhere inside the app.
 */
export function isHttpUrl(value: string): boolean {
  return /^https?:\/\//i.test(value.trim());
}
